import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Panel } from 'primereact/panel';

import {
  TOA_GetFertilizationsEmbryos,
  TOA_GetFertilizationsIntEmbryos,
} from '@/rtk-query.gql';

import { groupCanesByGrade, transformEmbryoData } from '../utils/utils';

type FreezeSubGridInfoProps = {
  liveEmbryos: TOA_GetFertilizationsEmbryos[];
  tempEmbryos: TOA_GetFertilizationsIntEmbryos[];
};

export const FreezeSubGridInfo = ({
  liveEmbryos,
  tempEmbryos,
}: FreezeSubGridInfoProps) => {
  const { data: aspirationData, canes } = transformEmbryoData(
    liveEmbryos,
    tempEmbryos,
  );

  const { grade1Canes, grade2Canes } = groupCanesByGrade(canes);
  return (
    <div>
      <DataTable value={aspirationData}>
        <Column field="category" header=""></Column>
        <Column field="d65" header="D6.5"></Column>
        <Column field="d7" header="D7"></Column>
        <Column field="totals" header="Totals"></Column>
      </DataTable>
      <div className="cane-counts">
        <Panel header="Cane Distribution">
          <div className="cane-counts__grade">
            <h4>Grade 1:</h4>
            {grade1Canes.map((cane) => (
              <div key={cane.currentcane}>
                {cane.currentcane}: {cane.currentcanecount}
              </div>
            ))}
          </div>

          <div className="cane-counts__grade">
            <h4>Grade 2:</h4>
            {grade2Canes.map((cane) => (
              <div key={cane.currentcane}>
                {cane.currentcane}: {cane.currentcanecount}
              </div>
            ))}
          </div>
        </Panel>
      </div>
    </div>
  );
};
